import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setAuthAction } from "../actions";

import { AppController } from "../controllers";

class App extends Component {

	constructor(props) {
		super(props);

		this.controller = new AppController(this);
	}

	componentWillMount(){
		// this.controller.fetchUser();
	}

	render() {
		return this.props.children;
	}
}

const map = state => {
	return {

	};
};

export default connect(map, {setAuthAction})(App);


// WEBPACK FOOTER //
// src/containers/App.js